import React from 'react';

import styles from './styles.module.scss';

interface Props {
  capsLetterFlag: string;
  numberFlag: string;
  pwdLengthFlag: string;
  specialFlag: string;
  fontSize?: string;
  isFromSignUp?: boolean;
}

const PWDRequisite: React.FC<Props> = ({
  capsLetterFlag,
  numberFlag,
  pwdLengthFlag,
  specialFlag,
  isFromSignUp,
  fontSize = '16px',
}): JSX.Element => (
  <div style={{ display: 'inline-flex' }} className={`${styles.passwordRequisiteDiv} fs-unmask`}>
    <p className={styles[pwdLengthFlag]} style={isFromSignUp ? {} : { fontSize }}>
      8 characters &nbsp;
    </p>
    <p className={styles[capsLetterFlag]} style={isFromSignUp ? {} : { fontSize }}>
      1 uppercase &nbsp;
    </p>
    <p className={styles[numberFlag]} style={isFromSignUp ? {} : { fontSize }}>
      1 number &nbsp;
    </p>
    <p className={styles[specialFlag]} style={isFromSignUp ? {} : { fontSize }}>
      1 special character &nbsp;
    </p>
  </div>
);

export default PWDRequisite;
